"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ui_1 = require("../ui");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const PostInstallAlert = ({ link }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (React.createElement(react_core_1.Alert, { variant: "warning", isInline: true, "data-testid": "alert-modify-platform-config", title: React.createElement("p", null,
            t("ai:Modify your platform configuration to access your platform's features directly in OpenShift."),
            ' ',
            React.createElement(ui_1.ExternalLink, { href: link }, t('ai:Learn more about configuration.'))) }));
};
exports.default = PostInstallAlert;
//# sourceMappingURL=PostInstallAlert.js.map